<app-public-header *ngIf="!isAuthenticated"></app-public-header>
<div class="container mb-30" [ngClass]="{'pt-80': !isAuthenticated}">


    <!-- Back -->
    <a (click)="backTo()"
        class="text-decoration-none clr-cc-vilot text-regular-medium fs-16 c-p text-primary mb-3 mt-20 d-inline-flex align-items-center">
        <i class="bi bi-arrow-left me-2"></i>
        <ng-container [ngSwitch]="fromTab">
            <span *ngSwitchCase="'applied'">Back to applied jobs</span>
            <span *ngSwitchCase="'saved'">Back to saved jobs</span>
            <span *ngSwitchCase="'campAustraliaJobs'">Back to all jobs</span>
            <span *ngSwitchDefault>Back to all jobs</span>
        </ng-container>
    </a>

    <!-- CENTER COLUMN -->
    <div class="row justify-content-center">
        <div class="col-xl-8 col-lg-9 col-md-11">

            <!-- JOB DETAILS -->
            <div class="card job-detail-card p-4 mb-4">

                <!-- Header -->
                <div class="d-flex justify-content-between align-items-start">
                    <div class="d-flex gap-3">
                        <img [src]="
              job_details?.school?.profile_image
                ? job_details.school.profile_image
                : '../../../../assets/images/teacher-static-profile.png'
            " class="rounded-circle job-logo" alt="School profile" />
                        <div *ngIf="job_details">
                            <h5 class="fw-semibold mb-1">{{ job_details.job_title }}</h5>
                            <div class="text-muted small mt-5">
                                {{ job_details.school?.title || '-' }} <span *ngIf="job_details.school_level"
                                    class="mx-1">|</span> {{
                                job_details.school_level}}
                            </div>
                            <div class="d-flex gap-2 mt-5 flex-wrap">
                                <span class="badge badge-soft-primary">{{ job_details.job_type }}</span>
                                <span *ngIf="job_details.is_boost_job" class="badge badge-soft-success">Promoted</span>
                                <span *ngIf="job_details.expiring_soon" class="badge badge-soft-danger">Expiring
                                    soon</span>
                            </div>
                        </div>
                    </div>

                    <!-- <i class="bi bi-bookmark"></i> -->
                </div>

                <!-- Meta -->
                <div class="row  small mt-24" *ngIf="job_details">
                    <div class="col-sm-12 mb-2"><b class="text-regular-medium">Job Type:</b><span
                            class="txt-regular fs-14"> {{
                            job_details.job_type || '-'
                            }}</span></div>
                    <div class="col-sm-12 mb-2"><b class="text-regular-medium">Subjects:</b> <span
                            class="txt-regular fs-14"> {{ job_details.subjects || '-'
                            }}</span></div>
                    <div class="col-sm-12 mb-2"><b class="text-regular-medium">Location:</b> <span
                            class="txt-regular fs-14"> {{ job_details.job_location || '-' }}</span>
                    </div>
                    <div class="col-sm-12 mb-2"><b class="text-regular-medium">Job Posted:</b> <span
                            class="txt-regular fs-14"> {{ job_details.job_posted || '-'
                            }}</span></div>
                    <div class="col-sm-12 mb-2"><b class="text-regular-medium">Levels:</b> <span
                            class="txt-regular fs-14"> {{ job_details.school_level || '-'
                            }}</span>
                    </div>
                    <div *ngIf="job_details.apply_through === 'B'" class="col-sm-12 mb-2"><b
                            class="text-regular-medium">Applied Through
                            :</b> <span class="txt-regular fs-14"> {{ url || '-' }}</span>
                    </div>
                    <div class="col-sm-12 mb-2"><b class="text-regular-medium">Role type:</b> <span
                            class="txt-regular fs-14"
                            *ngFor="let role of job_details.job_multi_role_type; let i = index">
                            {{ role.tag || '-'
                            }},</span>
                    </div>
                </div>
                <hr>

                <!-- Description -->
                <h6 class="fw-semibold">Job description</h6>
                <div class="job-description mt-3" [innerHTML]="job_details?.job_description || '-'"></div>
            </div>

            <!-- APPLY SECTION (CENTERED, SAME COLUMN) -->
            <ng-container *ngIf="isAuthenticated">
                <ng-container *ngIf="fromApplied; else allJobsBlock">
                    <div *ngIf="job_details.apply_through === 'CCW'">
                        <div class="card apply-card p-4 mt-20">
                            <!-- Applicant Resume Section -->
                            <div class="mb-3">
                                <div *ngIf="fromApplied" class="">
                                    <label class="fw-semibold small">Uploaded Resume</label>
                                    <br>
                                    <span *ngIf="applicantResumeUrl; else noResume">
                                        <label class="fw-semibold small text-success">{{
                                            applicantResumeUrl.split('/').pop()
                                            }}</label>
                                        <a [href]="applicantResumeUrl" class="txt-regular fs-12 ml-10" target="_blank"
                                            download>
                                            <i class="bi bi-download"></i> Download
                                        </a>
                                    </span>
                                    <ng-template #noResume>
                                        <label class="text-danger">No file uploaded</label>
                                    </ng-template>
                                </div>
                                <div class="upload-box mt-2" (click)="resumeInput.click()" style="cursor:pointer;">

                                    <input #resumeInput type="file" accept=".pdf,.doc,.docx" style="display:none"
                                        (change)="onFileSelected($event, 'resume')" />
                                    <ng-template #resumeUpload>
                                        <span>Click here to upload</span>
                                    </ng-template>
                                    <div class="text-muted small">Upload word doc or PDF</div>
                                    <ng-container *ngIf="resumeFileName; else resumeUpload">
                                        <label class="d-flex align-items-center justify-content-center w-100 ml-5">
                                            <span>{{ resumeFileName }}</span>
                                            <button type="button" class="btn btn-sm btn-link text-danger p-0 ms-2"
                                                (click)="removeFile('resume', resumeInput); $event.stopPropagation();">Remove</button>
                                        </label>
                                    </ng-container>
                                </div>
                                <!-- Remove individual upload buttons, handled by single update button below -->
                            </div>
                            <!-- Applicant Cover Letter Section -->
                            <div class="mb-3 mt-20">

                                <div *ngIf="fromApplied">
                                    <label class="fw-semibold small">Uploaded Cover Letter</label>
                                    <br>
                                    <div class="" *ngIf="applicantCoverLetterUrl; else noCover">
                                        <label class="fw-semibold small text-success me-2 ">{{
                                            applicantCoverLetterUrl.split('/').pop() }}</label>
                                        <a [href]="applicantCoverLetterUrl" class="txt-regular fs-12 ml-10"
                                            target="_blank" download>
                                            <i class="bi bi-download"></i> Download
                                        </a>
                                    </div>
                                    <ng-template #noCover>
                                        <label class="text-danger">No file uploaded</label>
                                    </ng-template>
                                </div>
                                <label *ngIf="!fromApplied" class="fw-semibold small fs-16">Upload Cover Letter</label>
                                <p class="txt-regular">Applicants who include a cover letter are more likely to get
                                    hired.
                                </p>
                                <div class="upload-box mt-2" (click)="coverInput.click()" style="cursor:pointer;">
                                    <input #coverInput type="file" accept=".pdf,.doc,.docx" style="display:none"
                                        (change)="onFileSelected($event, 'cover')" />
                                    <ng-template #coverUpload>
                                        <span>Click here to upload</span>
                                    </ng-template>
                                    <div class="text-muted small">Upload word doc or PDF</div>
                                    <ng-container *ngIf="coverFileName; else coverUpload">
                                        <span class="d-flex align-items-center justify-content-center w-100">
                                            <span>{{ coverFileName }}</span>
                                            <button type="button" class="btn btn-sm btn-link text-danger p-0 ms-2"
                                                (click)="removeFile('cover', coverInput); $event.stopPropagation();">Remove</button>
                                        </span>
                                    </ng-container>
                                </div>
                                <!-- Remove individual upload buttons, handled by single update button below -->
                            </div>
                            <p *ngIf="!fromApplied" class="text-muted small">
                                By applying, you permit sharing your ClassCover profile with the school.
                            </p>
                            <button *ngIf="!fromApplied && job_details.job_type === 'Casual'" (click)="quickApplyJob()"
                                class="cc_p_btn d-flex justify-content-end fit-content">Quick apply</button>
                            <div *ngIf="!fromApplied && job_details.job_type !== 'Casual'">
                                <button (click)=" quickApplyJob()"
                                    class="cc_p_btn d-flex justify-content-end fit-content">
                                    Apply
                                    for this job</button>
                            </div>
                            <button (click)="uploadApplicantDocument('resume')"
                                [ngClass]="{'disabled': !resumeFile && !coverFile}"
                                class="cc_p_btn d-flex justify-content-end fit-content mt-10">Update resume and cover
                                letter</button>
                        </div>
                    </div>
                </ng-container>
                <ng-template #allJobsBlock>
                    <div class="card apply-card p-4 mt-20">
                        <div class="alert alert-soft-primary d-flex gap-2 small">
                            <i class="bi bi-lightbulb"></i>
                            Uploading a cover letter and resume improve your chances of getting shortlisted.
                        </div>
                        <hr>
                        <div *ngIf="job_details.job_type !== 'Casual'">
                            <p class="txt-regular">Make sure your profile is complete with all relevant documentation,
                                information and
                                references before applying.</p>

                            <p class="txt-regular mt-5">Tell this school a bit about yourself and why you are interested
                                in
                                working there.
                            </p>
                        </div>
                        <div *ngIf="job_details.job_type === 'Casual'">
                            <p class="txt-regular">Quick apply to this job with your ClassCover profile.You may also
                                upload your updated resume and cover letter if you wish to do so.
                            </p>
                        </div>
                        <!-- Applicant Resume Section -->
                        <div class="mb-3">
                            <label class="fw-semibold small fs-16">Upload Resume</label>
                            <div class="upload-box mt-2" (click)="resumeInput.click()" style="cursor:pointer;">

                                <input #resumeInput type="file" accept=".pdf,.doc,.docx" style="display:none"
                                    (change)="onFileSelected($event, 'resume')" />
                                <ng-template #resumeUpload>
                                    <span>Click here to upload</span>
                                </ng-template>
                                <div class="text-muted small">Upload word doc or PDF</div>
                                <ng-container *ngIf="resumeFileName; else resumeUpload">
                                    <label class="d-flex align-items-center justify-content-center w-100 ml-5">
                                        <span>{{ resumeFileName }}</span>
                                        <button type="button" class="btn btn-sm btn-link text-danger p-0 ms-2"
                                            (click)="removeFile('resume', resumeInput); $event.stopPropagation();">Remove</button>
                                    </label>
                                </ng-container>
                            </div>
                            <!-- Remove individual upload buttons, handled by single update button below -->
                        </div>
                        <!-- Applicant Cover Letter Section -->
                        <div class="mb-3 mt-20">
                            <label class="fw-semibold small fs-16">Upload Cover Letter</label>
                            <p class="txt-regular">Applicants who include a cover letter are more likely to get hired.
                            </p>
                            <div class="upload-box mt-2" (click)="coverInput.click()" style="cursor:pointer;">
                                <input #coverInput type="file" accept=".pdf,.doc,.docx" style="display:none"
                                    (change)="onFileSelected($event, 'cover')" />
                                <ng-template #coverUpload>
                                    <span>Click here to upload</span>
                                </ng-template>
                                <div class="text-muted small">Upload word doc or PDF</div>
                                <ng-container *ngIf="coverFileName; else coverUpload">
                                    <span class="d-flex align-items-center justify-content-center w-100">
                                        <span>{{ coverFileName }}</span>
                                        <button type="button" class="btn btn-sm btn-link text-danger p-0 ms-2"
                                            (click)="removeFile('cover', coverInput); $event.stopPropagation();">Remove</button>
                                    </span>
                                </ng-container>
                            </div>
                            <!-- Remove individual upload buttons, handled by single update button below -->
                        </div>
                        <div *ngIf="job_details.job_type !== 'Casual'">
                            <p class="txt-regular mt-15">By applying for this position, you are giving permission to
                                share
                                your ClassCover profile with this school. Please make sure your ClassCover profile is
                                complete with all relevant documentation before applying.
                            </p>
                            <p class="txt-regular mt-15">Is your ClassCover profile up to date? If yes, click to apply.
                            </p>
                        </div>
                        <div *ngIf="job_details.job_type === 'Casual'">
                            <p class="txt-regular mt-15">This application is to apply to be on the school's casual list.
                                Make
                                sure your availability is up to date before applying.
                            </p>
                            <p class="txt-regular mt-15">By applying for this position, you are giving permission to
                                share your ClassCover profile with this school.
                            </p>
                        </div>
                        <div class="row justify-content-end mr-5">
                            <button *ngIf="job_details.job_type === 'Casual'" (click)="quickApplyJob()"
                                class="cc_p_btn d-flex justify-content-end fit-content ">Quick apply</button>
                            <button *ngIf="job_details.job_type !== 'Casual'" (click)=" quickApplyJob()"
                                class="cc_p_btn d-flex justify-content-end fit-content">
                                Apply
                                for this job</button>
                        </div>

                        <div *ngIf="job_details.apply_through != 'CCW'" class="mt-30">
                            <h2 class="user-title">This job also has an external application process.
                            </h2>
                            <p class="txt-regular">Please follow the link to apply for this role.
                            </p>
                            <div class="row justify-content-end mr-5">
                                <button (click)="ApplyExternal()"
                                    class="cc_p_btn d-flex justify-content-end fit-content">Apply
                                    now</button>
                            </div>
                        </div>
                    </div>
                </ng-template>


            </ng-container>
            <ng-container *ngIf="!isAuthenticated">
                <div class="public-cta-box card p-4 mb-4 mt-4 text-center">
                    <h5 class="mb-2">It's quick and easy to sign up to apply for jobs and receive new job alerts</h5>
                    <p class="mb-2 mt-10">We have thousands of schools and education organisations using ClassCover jobs
                        to
                        hire for
                        their next role.</p>
                    <div class="d-flex flex-column align-items-center justify-content-center">
                        <a role="button" (click)="login()"
                            class="cc-blue-btn pl-20 pt-10 pr-20 fs-14 mt-10 fit-content ">I have a
                            ClassCover account &mdash;
                            Login</a>
                    </div>
                    or
                    <div class="d-flex flex-column align-items-center justify-content-center">
                        <a role="button" (click)="signup()"
                            class="cc-blue-btn pl-20 pt-10 pr-20 fs-14 mt-10 fit-content ">I don't
                            have a
                            ClassCover account &mdash;
                            Sign Up</a>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>